import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../assets/img/logo.svg";
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/css/style.css";
import { Tooltip } from "bootstrap"; // Import Tooltip directly from Bootstrap

const Header = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const tooltipTriggerList = [].slice.call(
      document.querySelectorAll('[data-toggle="tooltip"]')
    );
    tooltipTriggerList.forEach(function (tooltipTriggerEl) {
      new Tooltip(tooltipTriggerEl);
    });
  }, []);

  const handleNavClick =
    (path, options = {}) =>
    (e) => {
      e.preventDefault();
      if (path === "/") {
        sessionStorage.setItem("isLoggedIn", "false");
        navigate(path, { replace: true });
      } else {
        navigate(path, options);
      }
    };

  const handleExternalLinkClick = (url) => (e) => {
    e.preventDefault();
    window.open(url, "_blank");
  };

  return (
    <header>
      <nav className="navbar navbar-expand-lg">
        <a
          href="#"
          onClick={handleNavClick("/customerscreen")}
          className="navbar-brand"
        >
          <img src={logo} alt="Logo" />
        </a>
        <button
          className="navbar-toggler"
          data-toggle="collapse"
          data-target="#navbarCollapse"
        >
          <span className="navbar-toggler-icon">
            <i className="fa-solid fa-bars"></i>
          </span>
        </button>
        <div className="collapse navbar-collapse" id="navbarCollapse">
          <ul className="navbar-nav ml-auto">
            <li className="navbar-item">
              <a
                href="#"
                onClick={handleExternalLinkClick(
                  "https://youtube.com/playlist?list=PLOJaMjRtKWl65JKeeDMNUyYvXUY6N1VTK"
                )}
                className="nav-link"
              >
                FAQs
              </a>
            </li>
            <li className="navbar-item">
              <a
                href="#"
                onClick={handleExternalLinkClick(
                  "https://youtube.com/playlist?list=PLOJaMjRtKWl65JKeeDMNUyYvXUY6N1VTK"
                )}
                className="nav-link"
              >
                CMS Videos
              </a>
            </li>
            <li className="navbar-item">
              <a
                className="nav-link"
                data-toggle="tooltip"
                data-placement="bottom"
                title="For any information or product query, please mark an email to ask.cms@indusind.com"
              >
                Contact Us
              </a>
            </li>
            <li className="navbar-item">
              <a
                href="#"
                onClick={handleNavClick("/", { replace: true })}
                className="nav-link"
              >
                Sign out
              </a>
            </li>
          </ul>
        </div>
      </nav>
    </header>
  );
};

export default Header;
